import { CustomerOptions, PAGE_TYPE, PLATFORMS } from '@amzn/journeys-common';
import type { PlacementsSectionConfig } from 'features/traffic/campaigns/campaign-configs/types';
import { detailPageCustomerOptions } from '../../customerOptions.utils';
import { PLACEMENT_COMPONENTS } from '../../placement-component-schema-utils';
import {
  LOOM_DESKTOP_INLINE_SLOT,
  LOOM_DESKTOP_TOP_SLOT,
  LOOM_MOBILE_INLINE_SLOT,
  LOOM_MOBILE_TOP_SLOT,
  PLACEMENT_WEBLAB_LIFESTYLE,
} from '../constants';
import { FeaturedBrandsKeywords } from './components';

const placementComponents = {
  [PLACEMENT_COMPONENTS.PLATFORM_AND_LANGUAGES]: true,
  [PLACEMENT_COMPONENTS.SLOTS]: true,
  [PLACEMENT_COMPONENTS.TIME_RANGE]: true,
  [PLACEMENT_COMPONENTS.WEBLAB]: false,
  [PLACEMENT_COMPONENTS.IMPRESSION_CAPPING]: false,
  [PLACEMENT_COMPONENTS.CUSTOMERS]: false,
  [PLACEMENT_COMPONENTS.GUARANTEE]: false,
  [PLACEMENT_COMPONENTS.SCHEDULING]: false,
  [PLACEMENT_COMPONENTS.DEVICE_TYPE]: false,
  [PLACEMENT_COMPONENTS.BULLSEYE]: false,
  [PLACEMENT_COMPONENTS.MVT]: false,
  [PLACEMENT_COMPONENTS.ADDITIONAL_INCLUDES]: false,
  [PLACEMENT_COMPONENTS.ADDITIONAL_EXLUDES]: false,
};

const featuredBrandsSlot = {
  [PLATFORMS.DESKTOP]: [
    LOOM_DESKTOP_TOP_SLOT,
    LOOM_DESKTOP_INLINE_SLOT,
  ],
  [PLATFORMS.MOBILE]: [
    LOOM_MOBILE_TOP_SLOT,
    LOOM_MOBILE_INLINE_SLOT,
  ],
};

const placementDefaultsEnabled = false;

export const slotOptions = {
  AEAmazon: featuredBrandsSlot,
  AUAmazon: featuredBrandsSlot,
  BEAmazon: featuredBrandsSlot,
  BRAmazon: featuredBrandsSlot,
  CAAmazon: featuredBrandsSlot,
  CNAmazon: featuredBrandsSlot,
  DEAmazon: featuredBrandsSlot,
  DEFAULT: featuredBrandsSlot,
  EGAmazon: featuredBrandsSlot,
  ESAmazon: featuredBrandsSlot,
  FRAmazon: featuredBrandsSlot,
  GBAmazon: featuredBrandsSlot,
  IEAmazon: featuredBrandsSlot,
  INAmazon: featuredBrandsSlot,
  ITAmazon: featuredBrandsSlot,
  JPAmazon: featuredBrandsSlot,
  MXAmazon: featuredBrandsSlot,
  NLAmazon: featuredBrandsSlot,
  PLAmazon: featuredBrandsSlot,
  RUAmazon: featuredBrandsSlot,
  SAAmazon: featuredBrandsSlot,
  SEAmazon: featuredBrandsSlot,
  SGAmazon: featuredBrandsSlot,
  TRAmazon: featuredBrandsSlot,
  USAmazon: featuredBrandsSlot,
};

const initialPlacementValues = {
  customerOptions: CustomerOptions.All,
  guarantee: 100,
  pageType: PAGE_TYPE.SEARCH,
  slotsDesktop: [
    LOOM_DESKTOP_TOP_SLOT,
  ],
  slotsMobile: [
    LOOM_MOBILE_TOP_SLOT,
  ],
  weblabName: PLACEMENT_WEBLAB_LIFESTYLE.name,
  weblabTreatment: PLACEMENT_WEBLAB_LIFESTYLE.treatment,
};

export const placementsSectionConfig: PlacementsSectionConfig = {
  CustomPlacementComponent: FeaturedBrandsKeywords,
  customerOptions: detailPageCustomerOptions,
  initialPlacementValues,
  placementComponents,
  placementDefaultsEnabled,
  slotOptions,
};
